import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import de from './locales/de.json'

/**
 * Deutsche Oberfläche, aber i18n-fähig gebaut: Texte stehen ausschliesslich in
 * den Sprachdateien. Eine englische Version ist damit später eine zusätzliche
 * JSON-Datei, kein Refactoring.
 */
export const DEFAULT_LANGUAGE = 'de'

void i18n.use(initReactI18next).init({
  resources: { de: { translation: de } },
  lng: DEFAULT_LANGUAGE,
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: { escapeValue: false }, // React escaped bereits
})

export default i18n
